/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SubjectSource = 'LOCAL' | 'KN' | 'KN_CREATED' | 'LPIS' | 'LPIS_CREATED' | 'MERGED';

export const SubjectSource = {
    LOCAL: 'LOCAL' as SubjectSource,
    KN: 'KN' as SubjectSource,
    KN_CREATED: 'KN_CREATED' as SubjectSource,
    LPIS: 'LPIS' as SubjectSource,
    LPIS_CREATED: 'LPIS_CREATED' as SubjectSource,
    MERGED: 'MERGED' as SubjectSource
};

